<template>
  <div class="kpi-rank-person-page">
    <div id="water-mark"></div>
    <van-tabs v-model="typeIndex" title-active-color="#3283fa" color="#3283fa" :sticky="true" :swipe-threshold="3" @change="setType">
        <van-tab v-for="(type, key) in types" :key="type" :title="type">                                                                                                                                      
          <van-list v-if="typeIndex === key" v-model="params.loading" :finished="params.finished" finished-text="— 暂无更多数据 —">

            <div v-if="typeIndex === 0 || typeIndex === 1">
              <van-cell-group class="self group" v-if="own_user_info">
                <van-cell :value="(own_user_info.score||0) + unit" title-class="title" value-class="value">
                  <template slot="title">
                    <span class="no-num">{{own_user_info.rank}}</span>
                      <div class="img_box f fc fvc"><img :src="own_user_info.avatar || 'https://j.weizan.cn/youxiang/images/avatar_default.jpg'"/></div>
                    <span class="word">
                      <div class="one-nowrap">{{own_user_info.name}}</div>
                      <div class="store-name one-nowrap" v-if="own_user_info.brandName"><span>({{own_user_info.brandName ? own_user_info.brandName : ''}})</span></div>
                      <div class="progress"><span :style="'width: calc(' + (own_user_info.percent||0)*100 + '%)'"></span></div>
                    </span>
                  </template>
                </van-cell>
              </van-cell-group>
            </div>

            <div v-if="typeIndex === 2 && list.length > 0">
              <van-cell-group class="cell-group">
                <van-field label="请选择开始日期" v-model="startTime" readonly @click="(flag = 1) && (show = !show)" :placeholder="startTime" input-align="right"/>
                <van-field label="请选择结束日期" v-model="endTime" readonly @click="(flag = 2) && (show = !show)" :placeholder="endTime" input-align="right"/>
              </van-cell-group>
            </div>

            <!-- 排行列表 -->
            <div class="kpi-rank-person-list">
              <div class="bottom-line">
                <div>总数</div>
                <div>
                  <span>{{Number(totalCount)}}</span> {{unit}}
                </div>
              </div>
              <div v-for="(item, key) in list" :key="key">
                <van-cell-group class="group">
                  <van-cell :value="(item.score||0) + unit" title-class="title" value-class="value">
                    <template slot="title">
                      <span v-if="key === 0"><i class="icon-no1"></i></span>
                      <span v-if="key === 1"><i class="icon-no2"></i></span>
                      <span v-if="key === 2"><i class="icon-no3"></i></span>
                      <span v-if="key !== 0 && key !== 1 && key !== 2" class="no-num">{{item.rank}}</span>
                      <div class="img_box f fc fvc"><img :src="item.avatar || 'https://j.weizan.cn/youxiang/images/avatar_default.jpg'"/></div>
                      <span class="word">
                        <div class="one-nowrap">{{item.name}}</div>
                        <div class="store-name one-nowrap" v-if="item.brandName"><span>({{item.brandName ? item.brandName : ''}})</span></div>
                        <div class="progress"><span :style="'width: calc(' + (item.percent||0)*100 + '%)'"></span></div>
                      </span>
                    </template>
                  </van-cell>
                </van-cell-group>
              </div>
            </div>

          </van-list>
        </van-tab>
      </van-tabs>

    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="onConfirm"
        @cancel="show = false"
      />
    </van-popup>

    <back-home :activity_id="activity_id" :user_id="user_id" :kpi_uid="kpi_userid" :share_uid="share_userid"></back-home>

  </div>
</template>

<script>
import backHome from '../../components/back-home.vue';
import { formatNumber } from '../../utils/tools';
export default {
  components: {
    backHome
  },
  data() {
    return {
      load: true,//默认一开始不执行@load的方法
      activity_id: localStorage.getItem('act_id'),
      user_id: localStorage.getItem('user_id'),
      kpi_userid: localStorage.getItem('kpi_user_id') || null,
      share_userid: localStorage.getItem('share_user_id') || null,
      titledoc: this.$route.query.title,
      unit: this.$route.query.unit,
      typeIndex: 0,
      params: {
        index: -1,
        size: -1,
        start_at: null,
        end_at: null,
        loading: false,
        finished: false,
      },
      list: [],
      rankType: this.$route.query.type,//排行类型
      types: ['总排行','昨日排行','每日排行'],
      own_user_info: null,
      startTime: new Date(),
      endTime: new Date(),
      minDate: new Date(),
      maxDate: new Date(),
      currentDate: new Date(),
      yesterday: new Date(new Date() - 24 * 60 * 60 * 1000),//昨天的时间
      today: new Date(),//今天的时间
      totalCount: 0,//总数
      show: false,
      flag: null
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.titledoc === '导购员奖励' ? document.title = this.titledoc + '排行' : document.title = '个人' + this.titledoc + '排行';
    this.maxDate.setFullYear(this.minDate.getFullYear() + 1);// 设置多大年份是后一年
    this.minDate.setFullYear(this.minDate.getFullYear() - 1);// 设置多大年份是前一年
    this.startTime = this.startTime.getFullYear() + '-' + formatNumber(this.startTime.getMonth() + 1) + '-' + formatNumber(this.startTime.getDate());
    this.endTime = this.startTime;
    this.yesterday = new Date(new Date() - 24 * 60 * 60 * 1000);
    this.yesterday = this.yesterday.getFullYear() + '-' + formatNumber(this.yesterday.getMonth() + 1) + '-' + formatNumber(this.yesterday.getDate())
    
    this.today = new Date();
    this.today = this.today.getFullYear() + '-' + formatNumber(this.today.getMonth() + 1) + '-' + formatNumber(this.today.getDate())
    
    this.getRankList();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    getRankList(){
      this.params.loading = true;
      this.$kpi.rank.getUserRankList({
        "actId": Number(this.activity_id),
        "kpiUserId": this.kpi_userid,
        "startTime": this.params.start_at,
        "endTime": this.params.end_at,
        "page": this.params.index || 1,
        "size": this.params.size || 50,
        "type": this.rankType
      }).then((res) => {
        this.params.loading = false;
        this.load = false;
        if(res.code==0){
          console.log(res)
          var data=res.data;
          this.own_user_info = data.list.length&&data.list[0].userData||{};
          this.totalCount = data.list.length&&data.list[0].totalScore||0;
          this.list = this.list.concat(data.list);
          let oTemp = null;
          let site = {logo:'https://j.weizan.cn/youxiang/icon.png',name:'优想互动'}||null;
          oTemp = this.$wm.set(80.2, this.list, site);
          document.getElementById('water-mark').appendChild(oTemp);
          this.params.finished = true;
        }else if(res.code==10200){
          this.params.finished = true;
        }
      });
    },
    setType(index) {
      this.params.loading = false;
      this.params.finished = false;
      this.list = [];
      this.params.index = 1;
      if (this.typeIndex === 0) {
        this.params.start_at = null;
        this.params.end_at = null;
      } else if (this.typeIndex === 1) {
        this.params.start_at = this.yesterday + ' 00:00:00';
        this.params.end_at = this.yesterday + ' 23:59:59';
      } else if (this.typeIndex === 2) {
        this.params.start_at = this.today + ' 00:00:00';
        this.params.end_at = this.today + ' 00:00:00';
      }
      var waterMark = document.getElementById('water-mark');
      var childs = waterMark.childNodes;
      var arr = [];
      for (var i = childs.length - 1; i >= 0; i--) {
        arr[i] = childs[i].innerHTML;
        waterMark.removeChild(childs[i]);
      }
      this.getRankList();
    },
    // 选中日期
    onConfirm(value) {
      console.log(value);
      this.show = !this.show;
      var date = new Date(value);
      var time = date.getFullYear() + '-' + formatNumber(date.getMonth() + 1) + '-' + formatNumber(date.getDate());
      if (this.flag === 1) {
        this.startTime = time;
      } else if (this.flag === 2) {
        this.endTime = time;
      }
      if(this.startTime&&this.endTime&&(new Date(this.startTime).getTime()>new Date(this.endTime).getTime())){
        this.$toast("开始时间不能大于结束时间");
        this.startTime=this.endTime;
        return;
      }
      this.params.finished = false;
      this.params.start_at = this.startTime + ' 00:00:00';
      this.params.end_at = this.endTime + ' 23:59:59';
      this.list = [];
      this.params.index = 1;
      this.getRankList();
    },
    /**
     * pupop弹框日期格式
     * @param type
     * @param value
     * @returns {*}
     */
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`;
      } else if (type === 'month') {
        return `${value}月`;
      } else if (type === 'day') {
        return `${value}日`;
      }
      return value;
    },
  },
};

</script>

<style lang="less" scoped>
.kpi-rank-person-page {
  height: 100vh;
  .self {
    margin-top: 10px;
  }
  .kpi-rank-person-list {
    .bottom-line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 15px;
      font-size: 14px;
      background: #fff;
      span {
        color: #5293fd;
      }
    }
  }
  .group {
    .value {
      color: #323232;
    }
    .van-cell {
      height: 80px;
    }
    .title {
      position: relative;
      z-index: 9;
      display: flex;
      align-items: center;
      min-width: 74%;
      max-width: 74%;
      .no-num {
        border: 2px solid #aedaff;
        box-sizing: border-box;
        background-color: #1986ff;
        color: #ffffff;
        text-align: center;
        width: 28px;
        max-width: 28px;
        min-width: 28px;
        height: 28px;
        border-radius: 50%;
        margin-right: 3px;
      }
      .img_box {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        margin: 0 5px;
        overflow: hidden;
        img{
          height: 100%;
        }
      }
      .word {
        position: relative;
        width: 66%;
        display: flex;
        flex-direction: column;
        .one-nowrap {
          height: 18px;
          line-height: 18px;
        }
        .store-name {
          font-size: 12px;
        }
        .progress {/*进度条*/
          position: relative;
          left: -4px;
          top: 2px;
          background-color: #eeeeee;
          width: 100%;
          height: 6px;
          margin: 0px 10px 0px 5px;
          border-radius: 4px;
          box-sizing: border-box;
          span {
            // width: 100%;
            position: absolute;
            left: 0px;
            background-color: #3283fa;
            height: 6px;
            border-radius: 4px;
          }
        }
      }
    }

    /deep/.van-cell {
      align-items: center;
    }
    /deep/.van-cell:not(:last-child)::after {
      left: 0;
    }

    i {display: block;position: relative;width: 30px;height: 30px;margin: 0 auto;}
    .icon-no1 {background: url(https://j.weizan.cn/youxiang/images/kpi-rank-no.png) no-repeat -5px -3px;background-size: 140px 38px;}
    .icon-no2 {background: url(https://j.weizan.cn/youxiang/images/kpi-rank-no.png) no-repeat -53px -3px;background-size: 140px 38px;}
    .icon-no3 {background: url(https://j.weizan.cn/youxiang/images/kpi-rank-no.png) no-repeat -106px -3px;background-size: 140px 38px;}
  }

  .cell-group {/*每日排行输入框样式*/
    .bottom-line::after {
      left: 15px;
    }
    /deep/.van-field__label {
      width: 150px;
      max-width: 200px;
    }
    /deep/.van-field__control {
      //text-align: right;
      color: #999999;
    }
  }
}

</style>
